export function pushUnique<T = string>(list: T[], id: T) {
    if (!list.includes(id)) {
        list.push(id);
    }
}
